module.exports = __webpack_public_path__ + "img/CAPTAIN_BIKE_315_DOWN_RIGHT.7ff67144.png";